"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SwipeableViews = _interopRequireDefault(require("./SwipeableViews"));

var _default = _SwipeableViews.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-swipeable-views/lib/index.js
// module id = 76
// module chunks = 0